import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { formatDate } from '../../../utils/formatter';
import Status from '../../shared/status/Status';
import Row from '../../shared/table/Row';
import SelectableRow from '../../shared/table/SelectableRow';
import Table from '../../shared/table/Table';

const MyVisitsTable = ({ visits, onVisitClick }) => {
  const isTabletView = useSelector((state) => state.screen.isTabletView);
  const tableRows = useMemo(
    () =>
      visits.map((visit, i) => (
        <SelectableRow key={i} onClick={() => onVisitClick(visit)}>
          {!isTabletView && <Row>{visit.id}</Row>}
          <Row>
            <Status status={visit.status} />
          </Row>
          {!isTabletView && <Row>{visit.vin}</Row>}
          <Row>{`${visit.brand} ${visit.model}`}</Row>
          <Row>{formatDate(visit.updatedAt)}</Row>
        </SelectableRow>
      )),
    [isTabletView, visits, onVisitClick],
  );

  return <Table columns={isTabletView ? mobileColumns : columns} data={tableRows} onRowClick={() => ({})} />;
};

const mobileColumns = [{ name: 'Статус' }, { name: 'Автомобіль' }, { name: 'Дата' }];

const columns = [{ name: '№' }, { name: 'Статус' }, { name: 'VIN' }, { name: 'Автомобіль' }, { name: 'Дата' }];

export default MyVisitsTable;
